<div *ngIf="testApiEndpoint$ | async as testApiEndpoint" class="test-api-endpoint-notification">
  <ng-container *ngIf="testApiEndpoint">
    <b>{{ testApiEndpoint }}</b><span>API endpoint is used. To change it click 5 times to "Sign In" on sign in page.</span>
  </ng-container>
</div>

